// extracted by mini-css-extract-plugin
export var cardContainer = "_qt-0";
export var cardHeader = "_qt-2";
export var collapsedState = "_qt-3";
export var dragHandle = "_qt-5";
export var dragHandleIcon = "_qt-6";
export var dragging = "_qt-1";
export var titleArea = "_qt-4";